<div>
    <h1 class="webapp-title">{{sectionInfo.title}}</h1>
    <!-- <form class="searchbar searchbar-init searchbar-inline searchbar-help-center" data-search-container=".faq-list"
      data-search-in=".item-title">
      <div class="searchbar-inner">
        <div class="searchbar-input-wrap">
          <input type="search" placeholder="Search">
          <i class="searchbar-icon"></i>
          <span class="input-clear-button"></span>
        </div>
        <span class="searchbar-disable-button if-not-aurora">Cancel</span>
      </div>
    </form> -->

    <div *ngFor="let obj of sectionInfo.array">
        <h3 class="medium-gray-title">{{obj.title}}</h3>
        <app-app-section-accordion [sectionInfo]="getObjectsForAccordion(obj)"></app-app-section-accordion>
    </div>

  </div>